// GSC Tab Configuration
export const GSC_TAB_CONFIG = [
  { key: "indexing", label: "Indexing" },
  { key: "core_web_vitals", label: "Core Web Vitals" },
  { key: "performance", label: "Performance" },
];
